import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface GuiaDisponibleNoEnviadaState {
	disponible: number | boolean;
	enviada: boolean;
}

const initialState: GuiaDisponibleNoEnviadaState | null = null as any;

const guiaDisponibleNoEnviadaStateSlice = createSlice({
	name: 'guiaDisponibleNoEnviadaState',
	initialState,
	reducers: {
		setGuiaDisponibleNoEnviadaState: (state, action: PayloadAction<GuiaDisponibleNoEnviadaState>) => {
			return action.payload;
		}
	}
});

export const { setGuiaDisponibleNoEnviadaState } = guiaDisponibleNoEnviadaStateSlice.actions;

export default guiaDisponibleNoEnviadaStateSlice.reducer;
